<template>
  <div class="f-modal-footer card-footer">
    <slot />
  </div>
</template>
<script>

export default {
  name: 'f-modal-footer'
}
</script>
